<template>
  <div class="mb-15">
    <div class="my-4">
      <date-pager v-model="yearMonthDate" />
    </div>
  
    <div v-if="isOverlayVisible" class="overlay"></div>
  
    <div class="d-flex mb-4">
      <v-spacer />
      <v-btn
        @click="downloadShiftPattern"
        color="primary"
        variant="outlined"
        :disabled="isFetching"
        class="mr-8"
      >
        <v-icon start>mdi-tray-arrow-down</v-icon>
        ダウンロード（日単位）
      </v-btn>
  
      <v-btn
        @click="downloadMonthlyShiftPattern"
        color="primary"
        variant="outlined"
        :disabled="isFetching"
      >
        <v-icon start>mdi-tray-arrow-down</v-icon>
        一括ダウンロード（月単位）
      </v-btn>
    </div>
  
    <v-progress-linear
      indeterminate
      color="primary"
      class="my-4"
      v-if="isFetching"
    ></v-progress-linear>
  
     <div>
      <div class="tabs-container">
        <v-tabs v-model="currentTab" color="primary">
          <v-tab :value="0" class="custom-tab">スタッフ予定表</v-tab>
          <v-tab :value="1" class="custom-tab">園児予定表</v-tab>
          <v-tab :value="2" class="custom-tab">スタッフ＆園児予定表</v-tab>
        </v-tabs>
      </div>
    </div>
  
    <div v-if="showMenu" :style="{ position: 'absolute', left: `${menuPosition.x}px`, top: `${menuPosition.y}px`, zIndex: 120}">
        <ul class="context-menu">
          <div style="height: 12px;"></div>
          <li v-for="option in contextMenuOptions" :key="option" @click="handleMenuSelect(option)">
            {{ option }}
          </li>
        </ul>
        <button @click="closeMenu" style="position: absolute; top: 2px; right: 6px;"><strong>×</strong></button>
    </div>
  
    <div>
      <v-window v-model="currentTab">
  
        <v-window-item :value="0">
          <div class="d-flex mb-4">
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-btn
              @click="openUpdatePlacement"
              color="primary"
              variant="outlined"
              :disabled="isFetching"
            >
              配置計算の更新
            </v-btn>
          </div>
  
          <scrollable-panels :initial-scroll-x="1400" :leftWidth="340">
            <template #left-panel-header>
              <div class="panel-header panel-left">
                <div style="user-select: none;">
                  <div style="height: 50px; width: 340px; border: solid 4px #f0f0f0;">
                    <v-btn size="small" block variant="text" color="black" @click="openDisplaySettings()" style="height: 50px;">
                      <span><v-icon>mdi-cog</v-icon> 配置計算表示設定</span>
                    </v-btn>
                  </div>
                  <template v-for="item in availableItems" :key="item.id">
                    <div 
                      v-if="selectedDisplayItems.includes(item.id)" 
                      class="replacement-heading-box"
                    >
                      <div 
                        class="replacement-label bold"
                        :class="{ 
                          '-secondary': item.type === 'secondary',
                          '-tertiary': item.type === 'tertiary',
                          '-quaternary': item.type === 'quaternary'
                        }"
                      >
                        {{ item.label }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
  
            <template #left-panel-body>
              <div class="panel-left" v-show="!loading">
                  <div 
                    class="schedule-row"
                    v-for="(schedule, i) in scheduleTableRows"
                    :key="`row-${i}`"
                  >
                    <div class="schedule-col name schedule-body-cell">
                      {{ schedule.name }}
                    </div>
                  </div>
              </div>
            </template>
  
            <template #center-panel-header>
              <div class="panel-header panel-center" :style="`width: ${24 * 200}px; user-select: none;`">
                <div 
                  class="header-col"
                  v-for="hourItem in tableCols"
                  :key="hourItem.hour"
                  :style="dynamicHeightStyle"
                >
                  <div class="hour-col">
                    {{ hourItem.hour }}
                  </div>
                  <div class="min-cols">
                    <div
                      v-for="item in hourItem.items"
                      :key="item.minute"
                      class="min-col"
                      :style="dynamicHeightStyleSelection"
                    >
                      <div class="minute-box minute-label">
                        {{ item.minute }}
                      </div>
                        <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(1)">
                          {{ item.requisite ? item.requisite.govExpected : '' }}
                        </div>
                        <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(2)">
                          {{ item.requisite ? item.requisite.expected : '' }}
                        </div>
                        <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(3)">
                          {{ item.sufficient ? item.sufficient.expected : '' }}
                        </div>
                        <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(4)">
                          {{ item.requisite && item.requisite.govActual !== null ? item.requisite.govActual : '-' }}
                        </div>
                        <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(5)">
                          {{ item.requisite && item.requisite.actual !== null ? item.requisite.actual : '-' }}
                        </div>
                        <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(6)">
                          {{ item.sufficient && item.sufficient.actual !== null ? item.sufficient.actual : '-' }}
                        </div>
                        <div class="minute-box replacement-label -tertiary" v-if="selectedDisplayItems.includes(7)">
                          {{ item.sufficient && item.sufficient.expected !== null && item.requisite && item.requisite.expected !== null ? (item.sufficient.expected - item.requisite.expected) : '-' }}
                        </div>
                        <div class="minute-box replacement-label -tertiary" v-if="selectedDisplayItems.includes(8)">
                          {{ item.sufficient && item.sufficient.actual !== null && item.requisite && item.requisite.actual !== null ? (item.sufficient.actual - item.requisite.actual) : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(9)">
                          {{ item.attendance ? item.attendance.age0 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(10)">
                          {{ item.attendance ? item.attendance.age1 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(11)">
                          {{ item.attendance ? item.attendance.age2 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(12)">
                          {{ item.attendance ? item.attendance.age3 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(13)">
                          {{ item.attendance ? item.attendance.age4 : '-' }}
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
  
            <template #center-panel-body>
              <div class="panel-center" v-show="!loading">
                  <div
                  v-for="(row, i) in scheduleTableRows"
                  :key="i"
                  class="schedule-row"
                  :style="`width: ${24 * 200}px;`"
                  v-show="!loading"
                  >
                    <div
                      v-for="(item, j) in row.items"
                      :key="j"
                      class="body-cell-hour"
                    >
                      <div
                        class="body-cell-minute"
                        v-for="(minItem, k) in item.items"
                        :key="k"
                        @mousedown="startSelection(minItem.isFilled, i, j, k, minItem.tableID, row.userId)"
                        @mousemove="selectRange(row.userId, minItem.isFilled, i, j, k, minItem.tableID)"
                        @mouseup="endSelection(row.userId, minItem.isFilled, $event, i, j, k)"
                        :class="{
                          'body-cell-removing': minItem.isFilled || isFillCell,
                          'body-cell-drawing': !minItem.isFilled,
                          'body-cell-error-drawing': isDrawingErorr
                        }"
                      >
                        <div
                          v-if="minItem.isFilled"
                          :style="`background-color: ${minItem.color}; height: 30px; color: ${minItem.fontColor};`"
                          class="body-cell-minute-content"
                          :class="getCellClass(minItem.isFilled, i, j, k)"
                        >
                          {{ minItem.abbreviation }}
                        </div>
                        <div v-if="!minItem.isFilled" 
                          :style="`height: 30px;`"
                          class="body-cell-minute-content"
                          :class="getCellClass(minItem.isFilled, i, j, k)"
                        >
                        </div>
                        <div
                            v-if="minItem.inSchool"
                            :style="`background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`"
                            class="body-cell-minute-content"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </template>
          </scrollable-panels>
        </v-window-item>
  
        <v-window-item :value="1">
          <div class="d-flex mb-4">
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-select
                variant="filled"
                label="クラス"
                density="compact"
                :items="classes"
                item-title="className"
                item-value="classId"
                v-model="selectedClassId"
                style="width: 100px;"
            >
            </v-select>
          </div>
  
          <div class="d-flex mb-4">
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-btn
              @click="openUpdatePlacement"
              color="primary"
              variant="outlined"
              :disabled="isFetching"
            >
              配置計算の更新
            </v-btn>
          </div>
  
          <div>
            <scrollable-panels :initial-scroll-x="1400" :leftWidth="340">
              <template #left-panel-header>
                <div class="panel-header panel-left">
                  <div style="user-select: none;">
                    <div style="height: 50px; width: 340px; border: solid 4px #f0f0f0;">
                      <v-btn size="small" block variant="text" color="black" @click="openDisplaySettings()" style="height: 50px;">
                        <span><v-icon>mdi-cog</v-icon> 配置計算表示設定</span>
                      </v-btn>
                    </div>
                      <template v-for="item in availableItems" :key="item.id">
                        <div 
                          v-if="selectedDisplayItems.includes(item.id)" 
                          class="replacement-heading-box"
                        >
                          <div 
                            class="replacement-label bold"
                            :class="{ 
                              '-secondary': item.type === 'secondary',
                              '-tertiary': item.type === 'tertiary',
                              '-quaternary': item.type === 'quaternary'
                            }"
                          >
                            {{ item.label }}
                          </div>
                        </div>
                      </template>
                  </div>
                </div>
              </template>
  
              <template #left-panel-body>
                <div class="panel-left">
                  <div 
                    class="schedule-row"
                    v-for="(schedule, i) in childScheduleTableRows"
                    :key="`row-${i}`"
                  >
                    <div class="schedule-col name schedule-body-cell" style="display: flex; justify-content: space-between; align-items: center;">
                      <span style="margin: auto;">{{ schedule.name }}</span>
                      <v-btn color="primary" variant="flat" size="small" style="margin: 16px;" @click="openEditScheduleModal(schedule.child, schedule.schedules)">
                        編集
                      </v-btn>
                    </div>
                  </div>
                </div>
              </template>
  
              <template #center-panel-header>
                <div class="panel-header panel-center" :style="`width: ${24 * 200}px;`">
                  <div 
                    class="header-col"
                    v-for="hourItem in tableCols"
                    :key="hourItem.hour"
                    :style="dynamicHeightStyle"
                  >
                    <div class="hour-col">
                      {{ hourItem.hour }}
                    </div>
                    <div class="min-cols">
                      <div
                        v-for="item in hourItem.items"
                        :key="item.minute"
                        class="min-col"
                        :style="dynamicHeightStyleSelection"
                      >
                        <div class="minute-box minute-label">
                          {{ item.minute }}
                        </div>
                          <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(1)">
                            {{ item.requisite ? item.requisite.govExpected : '' }}
                          </div>
                          <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(2)">
                            {{ item.requisite ? item.requisite.expected : '' }}
                          </div>
                          <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(3)">
                            {{ item.sufficient ? item.sufficient.expected : '' }}
                          </div>
                          <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(4)">
                            {{ item.requisite && item.requisite.govActual !== null ? item.requisite.govActual : '-' }}
                          </div>
                          <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(5)">
                            {{ item.requisite && item.requisite.actual !== null ? item.requisite.actual : '-' }}
                          </div>
                          <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(6)">
                            {{ item.sufficient && item.sufficient.actual !== null ? item.sufficient.actual : '-' }}
                          </div>
                          <div class="minute-box replacement-label -tertiary" v-if="selectedDisplayItems.includes(7)">
                            {{ item.sufficient && item.sufficient.expected !== null && item.requisite && item.requisite.expected !== null ? (item.sufficient.expected - item.requisite.expected) : '-' }}
                          </div>
                          <div class="minute-box replacement-label -tertiary" v-if="selectedDisplayItems.includes(8)">
                            {{ item.sufficient && item.sufficient.actual !== null && item.requisite && item.requisite.actual !== null ? (item.sufficient.actual - item.requisite.actual) : '-' }}
                          </div>
                          <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(9)">
                            {{ item.attendance ? item.attendance.age0 : '-' }}
                          </div>
                          <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(10)">
                            {{ item.attendance ? item.attendance.age1 : '-' }}
                          </div>
                          <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(11)">
                            {{ item.attendance ? item.attendance.age2 : '-' }}
                          </div>
                          <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(12)">
                            {{ item.attendance ? item.attendance.age3 : '-' }}
                          </div>
                          <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(13)">
                            {{ item.attendance ? item.attendance.age4 : '-' }}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
  
              <template #center-panel-body>
                <div class="panel-center">
                  <div
                    v-for="(schedule, i) in childScheduleTableRows"
                    :key="`row-${i}`"
                    class="schedule-row"
                    :style="`width: ${24 * 200}px;`"
                  >
                    <div
                      v-for="(item, j) in 24"
                      :key="j"
                      class="body-cell-hour"
                    >
                      <div
                        class="body-cell-minute"
                        v-for="(minItem, k) in 4"
                        :key="k"
                      >
                      <div v-if="schedule.schedules[0].status == 'isAbsent'" class="d-flex justify-center align-center" style="background-color: grey; height: 30px;">欠</div>
                        <div v-else>
                          <div
                            v-if="j*60 + k*15 >= schedule.schedules[0].startMin && j*60 + k*15 < schedule.schedules[0].endMin"
                            :style="`background-color: #029ec0; height: 30px;`"
                            class="body-cell-minute-content"
                          >
                            出
                          </div>
                          <div
                            v-if="attendances && attendances.attendances && attendances.attendances[i] && attendances.attendances[i].attendedAt && attendances.attendances[i].leftAt
                            && j * 60 + k * 15 >= formatHour(attendances.attendances[i].attendedAt) * 60 + formatMin(attendances.attendances[i].attendedAt) 
                            && j * 60 + k * 15 < formatHour(attendances.attendances[i].leftAt) * 60 + formatMin(attendances.attendances[i].leftAt)"
                            :style="`background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`"
                            class="body-cell-minute-content"
                          >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </scrollable-panels>
          </div>
        </v-window-item>
  
        <v-window-item :value="2">
          <div class="d-flex mb-4">
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-select
                variant="filled"
                label="クラス"
                density="compact"
                :items="classes"
                item-title="className"
                item-value="classId"
                v-model="selectedClassId"
                style="width: 100px;"
            >
            </v-select>
          </div>
          <div class="d-flex mb-4">
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-btn
              @click="openUpdatePlacement"
              color="primary"
              variant="outlined"
              :disabled="isFetching"
            >
              配置計算の更新
            </v-btn>
          </div>
  
          <scrollable-panels :initial-scroll-x="1400" :leftWidth="340">
            <template #left-panel-header>
              <div class="panel-header panel-left">
                <div style="user-select: none;">
                  <div style="height: 50px; width: 340px; border: solid 4px #f0f0f0;">
                    <v-btn size="small" block variant="text" color="black" @click="openDisplaySettings()" style="height: 50px;">
                      <span><v-icon>mdi-cog</v-icon> 配置計算表示設定</span>
                    </v-btn>
                  </div>
                    <template v-for="item in availableItems" :key="item.id">
                      <div 
                        v-if="selectedDisplayItems.includes(item.id)"  
                        class="replacement-heading-box"
                      >
                        <div 
                          class="replacement-label bold"
                          :class="{ 
                            '-secondary': item.type === 'secondary',
                            '-tertiary': item.type === 'tertiary',
                            '-quaternary': item.type === 'quaternary'
                          }"
                        >
                          {{ item.label }}
                        </div>
                      </div>
                    </template>
                </div>
              </div>
            </template>
  
            <template #left-panel-body>
              <div class="panel-left" v-show="!loading">
                <div style="height: 24px; background-color: #F8F5F5;">スタッフ</div>
                <div 
                class="staff-table"
                ref="StaffleftPanel"
                @scroll="syncScroll('staffleft')"
                style="overflow-y: auto; max-height: 420px;"
                >
                  <div 
                    class="schedule-row"
                    v-for="(schedule, i) in scheduleTableRows"
                    :key="`row-${i}`"
                  >
                    <div class="schedule-col name schedule-body-cell">
                      {{ schedule.name }}
                    </div>
                  </div>
                </div>
  
                <div style="height: 24px; background-color: #F8F5F5;">園児</div>
                <div 
                class="child-table"
                ref="ChildleftPanel"
                @scroll="syncScroll('childleft')"
                style="overflow-y: auto; max-height: 600px;"
                >
                  <div 
                    class="schedule-row"
                    v-for="(schedule, i) in childScheduleTableRows"
                    :key="`row-${i}`"
                  >
                    <div class="schedule-col name schedule-body-cell" style="display: flex; justify-content: space-between; align-items: center;">
                      <span style="margin: auto;">{{ schedule.name }}</span>
                      <v-btn color="primary" variant="flat" size="small" style="margin: 16px;" @click="openEditScheduleModal(schedule.child, schedule.schedules)">
                        編集
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </template>
  
            <template #center-panel-header>
              <div class="panel-header panel-center" :style="`width: ${24 * 200}px; user-select: none;`">
                <div 
                  class="header-col"
                  v-for="hourItem in tableCols"
                  :key="hourItem.hour"
                  :style="dynamicHeightStyle"
                >
                  <div class="hour-col">
                    {{ hourItem.hour }}
                  </div>
                  <div class="min-cols">
                    <div
                      v-for="item in hourItem.items"
                      :key="item.minute"
                      class="min-col"
                      :style="dynamicHeightStyleSelection"
                    >
                      <div class="minute-box minute-label">
                        {{ item.minute }}
                      </div>
                        <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(1)">
                          {{ item.requisite ? item.requisite.govExpected : '' }}
                        </div>
                        <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(2)">
                          {{ item.requisite ? item.requisite.expected : '' }}
                        </div>
                        <div class="minute-box replacement-label" v-if="selectedDisplayItems.includes(3)">
                          {{ item.sufficient ? item.sufficient.expected : '' }}
                        </div>
                        <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(4)">
                          {{ item.requisite && item.requisite.govActual !== null ? item.requisite.govActual : '-' }}
                        </div>
                        <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(5)">
                          {{ item.requisite && item.requisite.actual !== null ? item.requisite.actual : '-' }}
                        </div>
                        <div class="minute-box replacement-label -secondary" v-if="selectedDisplayItems.includes(6)">
                          {{ item.sufficient && item.sufficient.actual !== null ? item.sufficient.actual : '-' }}
                        </div>
                        <div class="minute-box replacement-label -tertiary" v-if="selectedDisplayItems.includes(7)">
                          {{ item.sufficient && item.sufficient.expected !== null && item.requisite && item.requisite.expected !== null ? (item.sufficient.expected - item.requisite.expected) : '-' }}
                        </div>
                        <div class="minute-box replacement-label -tertiary" v-if="selectedDisplayItems.includes(8)">
                          {{ item.sufficient && item.sufficient.actual !== null && item.requisite && item.requisite.actual !== null ? (item.sufficient.actual - item.requisite.actual) : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(9)">
                          {{ item.attendance ? item.attendance.age0 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(10)">
                          {{ item.attendance ? item.attendance.age1 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(11)">
                          {{ item.attendance ? item.attendance.age2 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(12)">
                          {{ item.attendance ? item.attendance.age3 : '-' }}
                        </div>
                        <div class="minute-box replacement-label -quaternary" v-if="selectedDisplayItems.includes(13)">
                          {{ item.attendance ? item.attendance.age4 : '-' }}
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
  
            <template #center-panel-body>
              <div class="panel-center" v-show="!loading">
                <div style="height: 24px; background-color: #F8F5F5;"></div>
                <div
                class="staff-table"
                ref="StaffcenterPanel"
                @scroll="syncScroll('staffcenter')"
                style="overflow-y: auto; max-height: 420px;"
                >
                  <div
                  v-for="(row, i) in scheduleTableRows"
                  :key="i"
                  class="schedule-row"
                  :style="`width: ${24 * 200}px;`"
                  v-show="!loading"
                  >
                    <div
                      v-for="(item, j) in row.items"
                      :key="j"
                      class="body-cell-hour"
                    >
                      <div
                        class="body-cell-minute"
                        v-for="(minItem, k) in item.items"
                        :key="k"
                        @mousedown="startSelection(minItem.isFilled, i, j, k, minItem.tableID, row.userId)"
                        @mousemove="selectRange(row.userId, minItem.isFilled, i, j, k, minItem.tableID)"
                        @mouseup="endSelection(row.userId, minItem.isFilled, $event, i, j, k)"
                        :class="{
                          'body-cell-removing': minItem.isFilled || isFillCell,
                          'body-cell-drawing': !minItem.isFilled,
                          'body-cell-error-drawing': isDrawingErorr
                        }"
                      >
                        <div
                          v-if="minItem.isFilled"
                          :style="`background-color: ${minItem.color}; height: 30px; color: ${minItem.fontColor};`"
                          class="body-cell-minute-content"
                          :class="getCellClass(minItem.isFilled, i, j, k)"
                        >
                          {{ minItem.abbreviation }}
                        </div>
                        <div v-if="!minItem.isFilled" 
                          :style="`height: 30px;`"
                          class="body-cell-minute-content"
                          :class="getCellClass(minItem.isFilled, i, j, k)"
                        >
                        </div>
                        <div
                            v-if="minItem.inSchool"
                            :style="`background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`"
                            class="body-cell-minute-content"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div style="height: 24px; background-color: #F8F5F5;"></div>
                <div 
                class="child-table"
                ref="ChildcenterPanel"
                @scroll="syncScroll('childcenter')"
                style="overflow-y: auto; max-height: 600px;"
                >
                  <div
                    v-for="(schedule, i) in childScheduleTableRows"
                    :key="`row-${i}`"
                    class="schedule-row"
                    :style="`width: ${24 * 200}px;`"
                  >
                    <div
                      v-for="(item, j) in 24"
                      :key="j"
                      class="body-cell-hour"
                    >
                      <div
                        class="body-cell-minute"
                        v-for="(minItem, k) in 4"
                        :key="k"
                      >
                        <div v-if="schedule.schedules[0].status == 'isAbsent'" class="d-flex justify-center align-center" style="background-color: grey; height: 30px;">欠</div>
                        <div v-else>
                          <div
                            v-if="j*60 + k*15 >= schedule.schedules[0].startMin && j*60 + k*15 < schedule.schedules[0].endMin"
                            :style="`background-color: #029ec0; height: 30px;`"
                            class="body-cell-minute-content"
                          >
                            出
                          </div>
                          <div
                            v-if="attendances && attendances.attendances && attendances.attendances[i] && attendances.attendances[i].attendedAt && attendances.attendances[i].leftAt
                            && j * 60 + k * 15 >= formatHour(attendances.attendances[i].attendedAt) * 60 + formatMin(attendances.attendances[i].attendedAt) 
                            && j * 60 + k * 15 < formatHour(attendances.attendances[i].leftAt) * 60 + formatMin(attendances.attendances[i].leftAt)"
                            :style="`background-color: #fdd35c; height: 10px; border: 1px solid #FFFFFF; margin-top: 2px;`"
                            class="body-cell-minute-content"
                          >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </scrollable-panels>
        </v-window-item>
      </v-window>  
    </div>
    
    <v-overlay
      v-model="loading"
      class="align-center justify-center"
      persistent
      z-index="5000"
    >
      <v-card
        height="200"
        width="200"
        class="d-flex align-center justify-center"
        rounded="lg"
        elevation="4"
      >
        <v-progress-circular
          color="primary"
          indeterminate
          :size="150"
        >
          処理中...
        </v-progress-circular>
      </v-card>
    </v-overlay>
  
    <v-dialog
      max-width="1080px"
      v-model="isEditScheduleModalOpen"
    >
      <v-card v-if="editingChildSchedule && editingChild">
        <v-card-title>シフトパターン追加</v-card-title>
        <v-card-text>
          <v-row class="mb-4">
            <v-col>
              <div class="mb-4">
                <h4>園児氏名</h4>
                <h3> {{ editingChild.lastName }} {{ editingChild.firstName }} </h3>
              </div>
            </v-col>
            <v-col>
              <div class="mb-4">
                <h4>日付</h4>
                <h3> {{ editingChildSchedule[0].date }}</h3>
              </div>
            </v-col>
          </v-row>
  
          <v-row class="mb-4">
            <v-col>
              <div class="mb-4">
                <h4>出欠</h4>
                <v-select
                  variant="outlined"
                  density="compact"
                  :items="absenseOptions"
                  item-title="title"
                  item-value="value"
                  v-model="editingChildSchedule[0].status"
                  color="primary"
                ></v-select>
              </div>
            </v-col>
            <v-col>
            </v-col>
          </v-row>
          <div class="mb-4" v-if="editingChildSchedule[0].status === 'isAbsent'">
            <h4>お休みの理由</h4>
            <v-select
              variant="outlined"
              density="compact"
              :items="absenseReasons"
              item-title="title"
              item-value="value"
              v-model="editingChildSchedule[0].statusReason"
              color="primary"
            ></v-select>
            <div class="my-2" v-if="editingChildSchedule[0].statusReason === 'others'">
              <v-textarea
                variant="outlined"
                label="コメント (必須)"
                v-model="editingChildSchedule[0].statusComment"
                color="primary"
              ></v-textarea>
            </div>
          </div>
          <v-row class="mb-4" v-if="editingChildSchedule[0].status === 'attending'">
            <v-col>
              <div>登園時間</div>
              <hour-minute-input
                v-model="editingChildSchedule[0].startMin"
              />
            </v-col>
            <v-col>
              <div>降園時間</div>
              <hour-minute-input
                v-model="editingChildSchedule[0].endMin"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          class="justify-center"
        >
          <v-btn
            variant="flat"
            color="red"
            class="mx-2"
            @click="deleteEditingShcedule"
          >
            削除
          </v-btn>
          <v-btn
            variant="flat"
            color="primary"
            class="mx-2"
            @click="saveEditingShcedule"
          >
            保存
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          indeterminate
          color="primary"
          v-if="isUpdatingSchedule"
        ></v-progress-linear>
      </v-card>
    </v-dialog>
  
    <v-dialog
      max-width="600px"
      v-model="isUpdatePlacement"
    >
      <v-card style="align-items: center; justify-content: center; height: 180px;">
        <v-card-title style="display: flex; align-items: center; justify-content: center;">
          <v-icon style="color: red">mdi-information-outline</v-icon>&nbsp;
          配置計算を実行しますか？
        </v-card-title>
        <v-card-text style="display: flex; align-items: center; justify-content: center; color: black;">配置計算には30秒ほど処理時間がかかります</v-card-text>
        <div style="display: flex; align-items: center; justify-content: center;">
          <v-card-actions>
            <v-btn
              variant="flat"
              color="primary"
              class="mx-2"
              @click="UpdateExpectedPlacement"
            >
              実行
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  
    <v-dialog
      max-width="600px"
      v-model="isCalcDialogOpen"
    >
      <v-card class="pa-4">
        <div class="modal-content">
          <div class="d-flex align-center justify-center mb-2" style="position: relative;">
            <v-checkbox
              v-model="isDisplaySettingAllSelected"
              label="全選択"
              hide-details
              density="compact"
              @update:model-value="toggleDisplaySettingAllSelection"
              class="mt-0 pt-0"
              style="position: absolute; left: 0;"
            ></v-checkbox>
  
            <h2 class="text-center ma-0">配置計算表示設定</h2>
          </div>
  
          <hr>
  
          <div class="checklist">
            <div v-for="item in availableItems" :key="item.id" class="checklist-item">
              <v-checkbox
                v-model="selectedDisplayItemsTemp"
                :value="item.id"
                :label="item.label"
                color="light-blue"
                density="compact"
              ></v-checkbox>
              <hr>
            </div>
          </div>
  
          <div class="modal-footer text-center mt-4">
            <v-btn @click="saveDisplaySettings" class="btn-primary" color="light-blue" dark>
              保存
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
  </template>
  
  <script lang="ts">
  // -------------------------------------------------------------
  // 【スクリプト部分はロジック破壊を避けるため、元の内容を維持しています】
  // -------------------------------------------------------------
  import { defineComponent } from 'vue'
  import dayjs from 'dayjs'
  
  import ScrollablePanels from '@/components/molecules/ScrollablePanels2.vue'
  import DatePager from '@/components/atoms/DatePager.vue'
  
  import { dailyScheduleModule } from '@/store/viewModules/work-schedule/dailyShceduleModule'
  import { ShiftPatternResponse, WorkSchedulePlacementSchema,  AttendanceScheduleMonthlySchema, AttendanceScheduleChildPartSchema, AttendanceScheduleDailyPartSchema, SearchNurseryAttendanceResponse, WorkDescriptionSettingResponse, FindOrCreateWSDisplaySettingResponse } from 'chaild-api/lib'
  
  import { attendanceScheduleModule } from '@/store/viewModules/work-schedule/attendanceScheduleModule'
  import { attendanceModule } from '@/store/dataModules/attendanceModule'
  import LocalDataService from '@/service/LocalDataService'
  import { monthlyScheduleModule } from "@/store/viewModules/work-schedule/monthlyScheduleModule";
  import { DayScheduleUpdateRequestTimetable } from '@/api/ApiShift'
  import ApiShift from '@/api/ApiWorkSchedule'
  import { NurseryUserResponse } from "chaild-api/src/component/nursery/user/types";
  import { workDescriptionModule } from "@/store/viewModules/work-schedule/workDescriptionModule";
  import { ShiftTimetableCategoryType } from 'chaild-api/src/constant/shiftTimetableCategory'
  import HourMinuteInput from '@/components/molecules/HourMinuteInput.vue'
  import { overlayModule } from '@/store/viewModules/overlayModule'
  
  
  interface CalculationItem {
    id: number;
    label: string;
    type: string;
    name: string;
  }
  interface DataType {
    availableItems: CalculationItem[];
    selectedDisplayItems: number[];
    selectedDisplayItemsTemp: number[];
    isFetching: boolean;
    isCalcDialogOpen: boolean;
    currentTab: number;
    searchFilters: any;
    selectedClassId: number | string | null;
    isSelecting: boolean;
    selectedCells: any;
    firstselectedCells: any;
    showMenu: boolean;
    menuPosition: any;
    contextMenuOptions: any;
    isOverlayVisible: boolean;
    tablePosition: any;
    tableIDCounter: number;
    lastAbbreviation: string | null;
    lastTableID: string | null;
    editingUser: any;
    selectedUser: any;
    editingDate: string | number | null;
    editingStart: number;
    editingEnd: number;
    deleateOn: boolean;
    deleateTableId: any;
    isDeleateFromHead: boolean;
    isDrawingErorr: boolean;
    isFillCell: boolean;
    partialDelete: any;
    loading: boolean;
    loadingCountDenominator: number;
    loadingCountNumerator: number;
    editingChildSchedule: AttendanceScheduleDailyPartSchema | null;
    editingChild: AttendanceScheduleChildPartSchema | null;
    isUpdatingSchedule: boolean;
    isUpdatePlacement: boolean;
  }
  
  interface DataRow {
    name: string;
    items: ScheduleHour[];
    userId: number;
  }
  
  interface ScheduleHour {
    hour: number;
    items: QuarterlyShcedule[];
  }
  
  interface ScheduleTableRowItem {
    name: string;
    attendanceCount: number;
    offCount: number;
    schedules: AttendanceScheduleDailyPartSchema[];
    child: AttendanceScheduleChildPartSchema;
  }
  
  interface QuarterlyShcedule {
    abbreviation?: string | null;
    color?: string | null;
    isFilled: boolean;
    inSchool?: boolean;
    minute: number;
    requisite?: {
      govExpected: number | null;
      govActual: number | null;
      expected: number | null;
      actual: number | null;
    };
    sufficient?: {
      expected: number | null;
      actual: number | null;
    };
    attendance?: {
      age0: number | null;
      age1: number | null;
      age2: number | null;
      age3: number | null;
      age4: number | null;
    };
    tableID?: number;
    tableInfo?: WorkDescriptionSettingResponse | null;
    category?: ShiftTimetableCategoryType | null;
  }
  
  const minutes = [0, 15, 30, 45]
  const hours = [...Array(24)].map((emp, i) => i)
  const emptySchedule: ScheduleHour[] = hours.map((hour) => {
    const items: QuarterlyShcedule[] = minutes.map((minute) => ({
      isFilled: false,
      minute
    }))
    return {
      hour,
      items
    }
  })
  
  const AbsenseReasons = [
    {
      title: '発熱',
      value: 'fever'
    },
    {
      title: '家庭の事情',
      value: 'personal'
    },
    {
      title: '溶連菌感染症',
      value: 'infStrep'
    },
    {
      title: 'マイコプラズマ肺炎',
      value: 'infMycoplasma'
    },
    {
      title: '手足口病',
      value: 'infHFMD'
    },
    {
      title: '伝染性紅斑（りんご病）',
      value: 'infSlappedCheek'
    },
    {
      title: 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）',
      value: 'infStomach'
    },
    {
      title: 'ヘルパンギーナ',
      value: 'infHerpangina'
    },
    {
      title: 'RSウィルス感染症',
      value: 'infRS'
    },
    {
      title: '帯状疱疹',
      value: 'infZoster'
    },
    {
      title: '突発性発しん',
      value: 'infRoseola'
    },
    {
      title: '伝染性膿痂疹（とびひ）',
      value: 'infImpetigo'
    },
    {
      title: 'その他',
      value: 'others'
    },
  ]
  
  export default defineComponent({
    components: {
      ScrollablePanels,
      DatePager,
      HourMinuteInput,
    },
    data: (): DataType => ({
        selectedDisplayItems: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        selectedDisplayItemsTemp: [],
  
        availableItems: [
          { id: 1, label: '予定: 必要配置保育者数 (国+自治体加配)', type:"", name: "requisiteGovExpected" },
          { id: 2, label: '予定: 必要配置保育者数 (国+自治体加配+園児個別加配)', type:"", name: "requisiteExpected" },
          { id: 3, label: '予定: 配置保育者数', type:"", name: "sufficientRequisite" },
          { id: 4, label: '実績: 必要配置保育者数 (国+自治体加配)', type: 'secondary', name: "requisiteGovActual" },
          { id: 5, label: '実績: 必要配置保育者数 (国+自治体加配+園児個別加配)', type: 'secondary', name: "requisiteActual" },
          { id: 6, label: '実績：配置保育者数', type: 'secondary', name: "sufficientActual" },
          { id: 7, label: '過不足 - 予定', type: 'tertiary', name: "excessOrDeficiencyExpected" },
          { id: 8, label: '過不足 - 実績', type: 'tertiary', name: "excessOrDeficiencyActual" },
          { id: 9, label: '出席予定 - 0歳児', type: 'quaternary', name: "attendanceAge0" },
          { id: 10, label: '出席予定 - 1歳児', type: 'quaternary', name: "attendanceAge1" },
          { id: 11, label: '出席予定 - 2歳児', type: 'quaternary', name: "attendanceAge2" },
          { id: 12, 'label': '出席予定 - 3歳児', type: 'quaternary', name: "attendanceAge3" },
          { id: 13, 'label': '出席予定 - 4歳以上', type: 'quaternary', name: "attendanceAge4" },
        ],
      isFetching: false,
      isCalcDialogOpen: false,
      currentTab: 0, // デフォルトでタブ1を表示
      searchFilters: {
          date: dayjs().format("YYYY-MM-DD"),
          age: "",
          classId: "",
          gender: "",
          status: "" as string,
          limit: 1000,
          skip: 0,
        },
      isSelecting: false,
      selectedCells: [],
      firstselectedCells: [],
      selectedClassId: null,
      showMenu: false,
      menuPosition: { x: 0, y: 0 },
      contextMenuOptions: ["休憩"], // 表示したい選択肢
      isOverlayVisible: false,
      tablePosition: [], // 位置情報を保存するオブジェクト
      tableIDCounter: 1,  // tableID用のカウンター
      lastAbbreviation: null, // 前の abbreviation を記録
      lastTableID: null, // 前の tableID を記録
      editingUser: [],
      selectedUser: [],
      editingDate: null,
      editingStart: 0,
      editingEnd: 0,
      deleateOn: false,
      deleateTableId: [],
      isDeleateFromHead: true,
      isDrawingErorr: false,
      isFillCell: false,
      partialDelete: [],
      loading: false,
      loadingCountDenominator: 1,
      loadingCountNumerator: 0,
      editingChildSchedule: null,
      editingChild: null,
      isUpdatingSchedule: false,
      isUpdatePlacement: false,
    }),
  
    watch: {
      async yearMonthDate(val: string) {
        const date = dayjs(val).format('YYYY-MM-DD')
        attendanceScheduleModule.onYearMonthChange(date)
        this.searchFilters.date = dayjs(val).format('YYYY-MM-DD');
        console.log(`日付遷移： ${this.searchFilters.date}`)
        this.searchAttendance();
        sessionStorage.setItem('wsdate', date);
      },
      selectedClassId: {
        deep: true,
        async handler() {
          this.searchFilters.classId = this.selectedClassId
          await this.searchAttendance();
        },
      },
      classes(newClasses) {
        if (newClasses && newClasses.length > 0) {
          this.selectedClassId = newClasses[0].classId;
        } else {
          this.selectedClassId = null;
        }
      },
    },
  
    computed: {
      isDisplaySettingAllSelected: {
        get() {
          return this.availableItems.length > 0 && 
                 this.selectedDisplayItems.length === this.availableItems.length;
        },
        set(value) {
          // get/setだけでは不十分な場合があるため、下のmethodsで制御します
        }
      },
      dynamicHeightStyle() {
        const BASE_HEIGHT = 50; // 項目がない場合の基本の高さ (px)
        const ITEM_HEIGHT = 25; // 項目1つあたりの増加高さ (px)
  
        // 選択項目数
        const itemCount = this.selectedDisplayItems.length; 
  
        // 項目数に応じた高さ
        const calculatedHeight = BASE_HEIGHT + (itemCount * ITEM_HEIGHT);
        
        return `height: ${calculatedHeight}px;`;
      },
      dynamicHeightStyleSelection() {
        const BASE_HEIGHT = 350 - (13 * 25); // 項目がない場合の基本の高さ (px)
        const ITEM_HEIGHT = 25; // 項目1つあたりの増加高さ (px)
  
        // 選択項目数
        const itemCount = this.selectedDisplayItems.length; 
  
        // 項目数に応じた高さ
        const calculatedHeight = BASE_HEIGHT + (itemCount * ITEM_HEIGHT);
        
        return `height: ${calculatedHeight}px;`;
      },
      yearMonthDate: {
        get() {
          return dailyScheduleModule.yearMonthDate
        },
        set(value: string) {
          dailyScheduleModule.setYearMonthDate(value)
          this.fetchDailySchedule()
        }
      },
      classes() {
        return attendanceScheduleModule.classes
      },
      dailySchedule(): ShiftPatternResponse[] {
        if (dailyScheduleModule.dailySchedule) {
          return dailyScheduleModule.dailySchedule.items.filter(item => {
            // itemsの中のnurseryUserが存在し、かつisHiddenがfalseであるかをチェック
            return item.nurseryUser && !item.nurseryUser.isHidden;
          });
        }
        return [];
      },
      placements(): WorkSchedulePlacementSchema[] {
        if (dailyScheduleModule.dailySchedule) {
          return dailyScheduleModule.dailySchedule.placements
        }
        return []
      },
      minutes(): number[] {
        return [0, 15, 30, 45]
      },
      hours() {
        return [...Array(24)].map((emp, i) => i)
      },
      emptySchedule(): ScheduleHour[] {
        return this.hours.map((hour) => {
          const items: QuarterlyShcedule[] = this.minutes.map((minute) => ({
            isFilled: false,
            minute
          }))
          return {
            hour,
            items
          }
        })
      },
      scheduleTableRows(): DataRow[] {
        return this.dailySchedule.map((schedule) => {
          let name = `${schedule.nurseryUser.lastName} ${schedule.nurseryUser.firstName}`
          if (name.length > 10) {
            name = name.slice(0, 10) + '...'
          }
  
          const userId = schedule.nurseryUser.userId
  
          const items = [...this.emptySchedule].map((hourItem) => {
            const minItems = hourItem.items.map((minute) => {
              const timeAsInt = (hourItem.hour * 60) + minute.minute
  
              const findSchedule = schedule.timetables.find((tt) => tt.startMin <= timeAsInt && tt.endMin > timeAsInt);
              const findAttendance = schedule.timecards.find((tc) => tc.startMin <= timeAsInt && tc.endMin > timeAsInt);
  
              if (findSchedule?.color) {
                // 白色とのコントラスト比を計算
                const contrastRatio = this.calculateContrastRatio(findSchedule.color, "#FFFFFF");
                const fontColor = contrastRatio < 3.0 ? "#000000" : "#FFFFFF";
                //console.log("コントラスト比： " + contrastRatio);
                //console.log("文字色： " +  fontColor);
  
                return {
                  isFilled: true,
                  inSchool: findAttendance ? findAttendance.inSchool : false,
                  abbreviation: findSchedule.abbreviation,
                  color: findSchedule.color,
                  fontColor: fontColor,
                  minute: minute.minute,
                  tableID: findSchedule?.timetableId,
                  tableInfo: findSchedule.workDescription,
                  category: findSchedule.category
                }
              }
  
              return {
                isFilled: false,
                inSchool: findAttendance ? findAttendance.inSchool : false,
                minute: minute.minute
              }
            })
  
            return {
              hour: hourItem.hour,
              items: minItems
            }
          })
  
          return {
            name,
            userId,
            items
          }
        })
      },
      staffIndex() {
        const staffs: number[] = [];
        this.scheduleTableRows.forEach(row => {
          return staffs.push(row.userId)
        })
        return staffs
      },
      tableCols() {
        return emptySchedule.map((s) => {
          const items = s.items.map((item) => {
            const min = s.hour * 60 + item.minute
            const find = this.placements.find((p) => {
              return p.startMin === min
            })
            console.log(find)
            if (find) {
              item.requisite = find.requisite
              item.sufficient = find.sufficient
              item.attendance = find.attendance?.expected
            }
            return item
          })
          return {
            hour: s.hour,
            items
          }
        })
      },
      attendanceSchedules() {
        return attendanceScheduleModule.attendanceSchedules
      },
      childScheduleTableRows(): ScheduleTableRowItem[] {
        return this.attendanceSchedules.filter((schedule: AttendanceScheduleMonthlySchema) => {
          if (!this.selectedClassId) {
            return true
          }
          const findClass = schedule.child.nurseryClasses.find((nc) => nc.classId === this.selectedClassId)
          if (findClass) {
            return true
          }
          return false
        }).map((schedule: AttendanceScheduleMonthlySchema) => {
          let name = `${schedule.child.lastName} ${schedule.child.firstName}`
          if (name.length > 10) {
            name = name.slice(0, 10) + '...'
          }
  
          const filteredSchedules = schedule.dailySchedules.filter((dailySchedule) => dailySchedule.date === this.yearMonthDate);
  
          return {
            name,
            attendanceCount: 0,
            offCount: 0,
            schedules: filteredSchedules,
            child: schedule.child
          }
        })
      },
      attendances: function (): SearchNurseryAttendanceResponse | null {
        const attendancesData = attendanceModule.attendances?.attendances;
        //出欠管理の並び順を園児予定の並び順に合わせる
        if (!attendancesData) {
          return null; // attendancesがnullまたはundefinedの場合
        }
  
        const attendanceItems = attendancesData.map(row => {
          return {
            childId: row.child.childId,
            attendedAt: row.attendedAt,
            leftAt: row.leftAt ?? dayjs().toISOString()
          };
        });

        const childIdsOrder = this.childScheduleTableRows.map(row => row.child.childId);

        const sortedAttendanceItems = childIdsOrder.map(childId =>
          attendanceItems.find(attendance => attendance.childId === childId) ?? null
        );

        return {
          attendances: sortedAttendanceItems,
          totalItemsCount: sortedAttendanceItems.length,
          summary: {}
        } as unknown as SearchNurseryAttendanceResponse;
      },
      workDescriptions() {
        return workDescriptionModule.workDescriptions;
      },
      isEditScheduleModalOpen: {
        get() {
          if (this.editingChildSchedule && this. editingChild) {
            return true
          }
          return false
        },
        set(value: boolean) {
          if (!value) {
            this.editingChildSchedule = null
            this.editingChild = null
          }
        }
      },
      absenseOptions() {
        return [
          {
            title: '出席',
            value: 'attending'
          },
          {
            title: '欠席',
            value: 'isAbsent'
          },
        ]
      },
      absenseReasons() {
        return AbsenseReasons
      },
    },
    methods: {
      toggleDisplaySettingAllSelection(val) {
        if (val) {
          this.selectedDisplayItemsTemp = this.availableItems.map(i => i.id);
        } else {
          this.selectedDisplayItemsTemp = [];
        }
      },
      openDisplaySettings() {
        this.selectedDisplayItemsTemp = this.selectedDisplayItems;
        this.isCalcDialogOpen = true;
      },
      async saveDisplaySettings() {
        await attendanceScheduleModule.updateDisplaySetting({
          requisiteGovExpected: this.selectedDisplayItemsTemp.indexOf(1) >= 0 ? true : false,
          requisiteExpected: this.selectedDisplayItemsTemp.indexOf(2) >= 0 ? true : false,
          sufficientRequisite: this.selectedDisplayItemsTemp.indexOf(3) >= 0 ? true : false,
          requisiteGovActual: this.selectedDisplayItemsTemp.indexOf(4) >= 0 ? true : false,
          requisiteActual: this.selectedDisplayItemsTemp.indexOf(5) >= 0 ? true : false,
          sufficientActual: this.selectedDisplayItemsTemp.indexOf(6) >= 0 ? true : false,
          excessOrDeficiencyExpected: this.selectedDisplayItemsTemp.indexOf(7) >= 0 ? true : false,
          excessOrDeficiencyActual: this.selectedDisplayItemsTemp.indexOf(8) >= 0 ? true : false,
          attendanceAge0: this.selectedDisplayItemsTemp.indexOf(9) >= 0 ? true : false,
          attendanceAge1: this.selectedDisplayItemsTemp.indexOf(10) >= 0 ? true : false,
          attendanceAge2: this.selectedDisplayItemsTemp.indexOf(11) >= 0 ? true : false,
          attendanceAge3: this.selectedDisplayItemsTemp.indexOf(12) >= 0 ? true : false,
          attendanceAge4: this.selectedDisplayItemsTemp.indexOf(13) >= 0 ? true : false,
        });
        this.selectedDisplayItems = this.selectedDisplayItemsTemp;
        sessionStorage.setItem('wsSelectedDisplayItems', this.selectedDisplayItems.join(','));
        this.isCalcDialogOpen = false;
      },
      async fetchDailySchedule() {
        //this.isFetching = true
        dailyScheduleModule.setDailySchedule(null)
        await dailyScheduleModule.getDailySchedule()
        //this.isFetching = false
      },
      async downloadShiftPattern() {
        this.isFetching = true;
        const response = await dailyScheduleModule.dlShiftPattern();
        if (response) {
          alert('エクスポートを開始しました。\nダウンロード一覧画面からご確認ください。')
        }
        this.isFetching = false;
      },
      async downloadMonthlyShiftPattern() {
        this.isFetching = true;
        const response = await dailyScheduleModule.dlMonthlyShiftPattern();
        if (response) {
          alert('エクスポートを開始しました。\nダウンロード一覧画面からご確認ください。')
        }
        this.isFetching = false;
      },
      async searchAttendance() {
        const nurseryId = LocalDataService.getNurseryId();
        if (nurseryId) {
          await attendanceModule
            .searchAttendance({
              nurseryId,
              ...this.searchFilters,
            })
            .catch();
        }
      },
      formatHour(date: string | null | undefined) {
        if (date) {
          return dayjs(date).format("H");
        }
        return null;
      },
      formatMin(date: string | null | undefined) {
        if (date) {
          const minuteNumber = parseInt(dayjs(date).format("m"), 10);
          return minuteNumber
        }
        return null;
      },
      syncScroll(source: string) {
        // nextTickでDOMがレンダリングされてからrefを参照
        this.$nextTick(() => {
          const StaffPanel = this.$refs.StaffPanel as HTMLElement | null;
          const StaffleftPanel = this.$refs.StaffleftPanel as HTMLElement | null;
          const StaffcenterPanel = this.$refs.StaffcenterPanel as HTMLElement | null;
          const ChildleftPanel = this.$refs.ChildleftPanel as HTMLElement | null;
          const ChildcenterPanel = this.$refs.ChildcenterPanel as HTMLElement | null;
  
          // refが正しく取得できた場合にスクロール同期を行う
          if (StaffleftPanel && StaffcenterPanel) {
            if (source === 'staffleft') {
              StaffcenterPanel.scrollTop = StaffleftPanel.scrollTop;
            } else if (source === 'staffcenter') {
              StaffleftPanel.scrollTop = StaffcenterPanel.scrollTop;
            } 
          }
          if (ChildleftPanel && ChildcenterPanel) {
            if (source === 'childleft') {
              ChildcenterPanel.scrollTop = ChildleftPanel.scrollTop;
            } else if (source === 'childcenter') {
              ChildleftPanel.scrollTop = ChildcenterPanel.scrollTop;
            } 
          }
        });
      },
      // 選択を開始する
      startSelection(isfill, i, j, k, tableID, userID) {
        //初期化
        this.editingUser = [];
        this.selectedCells = [];
        this.selectedUser = [];
  
        this.isSelecting = true;
        this.firstselectedCells = [{ row: i, col: j, min: k }];
        this.selectedCells = [{ row: i, col: j, min: k }];
        this.isFillCell = isfill ? true: false;
        if (!this.editingUser.includes(userID)) {
            this.editingUser.push(userID);
          }
        if (this.isFillCell) {
          this.deleateTableId.push(tableID);
        }
      },
      // 選択範囲を拡張する
      selectRange(userID, isfill, i, j, k, tableID) {
        if (this.isSelecting && !this.isFillCell) {  //追加処理の選択時
          if (isfill) {
            this.isDrawingErorr = true;
          } else {
            this.isDrawingErorr = false;
          }
  
          // 一度選択されたセルをクリア
          this.selectedCells = [];
          this.selectedUser = [];
          
          // firstselectedCellsから現在選択されているi, j, kまでをループ
          if (i >= this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min <= j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows <= i; rows++) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions <= j*10 + k; positions++) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: rows, col: cols, min: mins });
              }
            }
          } else if (i >= this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min > j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows <= i; rows++) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions >= j*10 + k; positions--) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: rows, col: cols, min: mins });
              }
            }
          } else if (i < this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min <= j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows >= i; rows--) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions <= j*10 + k; positions++) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: rows, col: cols, min: mins });
              }
            } 
          } else if (i < this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min > j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows >= i; rows--) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions >= j*10 + k; positions--) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: rows, col: cols, min: mins });
              }
            }
          }
  
          // 選択された範囲に特定の処理を実行
          this.highlightSelectedCells(isfill);
  
          //編集スタッフを格納
          if (!this.editingUser.includes(userID)) {
            this.editingUser.push(userID);
          }
        } else if (this.isSelecting && this.isFillCell) {  //削除処理の選択時
          // 一度選択されたセルをクリア
          this.selectedCells = [];
          this.selectedUser = [];
          
          // firstselectedCellsから現在選択されているi, j, kまでをループ
          if (i >= this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min <= j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows <= i; rows++) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions <= j*10 + k; positions++) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: this.firstselectedCells[0].row, col: cols, min: mins });
              }
            }
          } else if (i >= this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min > j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows <= i; rows++) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions >= j*10 + k; positions--) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: this.firstselectedCells[0].row, col: cols, min: mins });
              }
            }
          } else if (i < this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min <= j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows >= i; rows--) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions <= j*10 + k; positions++) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: this.firstselectedCells[0].row, col: cols, min: mins });
              }
            } 
          } else if (i < this.firstselectedCells[0].row && this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min > j*10 + k) {
            for (let rows = this.firstselectedCells[0].row; rows >= i; rows--) {
              for (let positions = this.firstselectedCells[0].col*10 + this.firstselectedCells[0].min; positions >= j*10 + k; positions--) {
                  // 選択されたセルをselectedCellsに追加
                  const cols =  (positions - (positions % 10)) /10
                  const mins = positions % 10
                  this.selectedCells.push({ row: this.firstselectedCells[0].row, col: cols, min: mins });
              }
            }
          }
          // 選択された範囲に特定の処理を実行
          this.highlightSelectedCells(isfill);
  
          //編集スタッフを格納
          if (!this.editingUser.includes(userID)) {
            this.editingUser.push(userID);
          }
  
          //削除するテーブルIDを追加
          if (tableID != null && !this.deleateTableId.includes(tableID)) {
            this.deleateTableId.push(tableID);
            console.log("追加されたデータ: " + this.deleateTableId);
          }
  
          // 配列の長さが2以上で、最後から2番目のデータがtableIDと同じ場合（選択範囲を縮めたときに削除するテーブルIDを削除）
          if (this.deleateTableId.length >= 2 && this.deleateTableId[this.deleateTableId.length - 2] === tableID) {
            this.deleateTableId.pop(); // 最後のデータを削除
            console.log("最後のデータが削除されました: " + this.deleateTableId);
          }
  
        }
      },
      // 選択を終了する
      async endSelection(userID, isfill, event, i, j, k) {
        this.isSelecting = false;
        this.editingDate = this.yearMonthDate;
        await this.executeActionOnSelectedCells();
        if (!this.isFillCell && isfill) {
          alert("予定を上書きすることはできません。\nすでに入力済みの予定を削除し、新たに予定を入力してください。")
          this.isDrawingErorr = false;
          this.selectedCells = [];
        } else if(!this.isFillCell) {
          this.menuPosition = { x: event.clientX -200, y: event.clientY };
          this.showMenu = true;
        }
        //削除処理を実行
        if (this.isFillCell) {
          this.deleteSelectedTable();
        }
      },
      async handleMenuSelect(option) {
        this.isOverlayVisible = true;
        overlayModule.setVisible(true);
        this.loading = true;
        this.showMenu = false;
        await this.addTimetableToEditingPattern(option);
        console.log("選択されたオプション: ", option);
        this.selectedCells = [];
        this.loading = false;
        this.loadingCountNumerator = 0;
        this.loadingCountDenominator = 1;
        this.isOverlayVisible = false;
        overlayModule.setVisible(false);
      },
      closeMenu() {
        this.selectedCells = [];
        this.showMenu = false;
      },
      // 選択されたセルをハイライト
      highlightSelectedCells(isfill) {
        this.getCellClass(isfill, this.selectedCells[0].row, this.selectedCells[0].col, this.selectedCells[0].min)
        this.getCellClass(isfill, this.selectedCells.slice(-1)[0].row, this.selectedCells.slice(-1)[0].col, this.selectedCells.slice(-1)[0].min)
      },
      // 選択されたセルに特定の処理を実行
      executeActionOnSelectedCells() {
        const staffnumberFirst = this.selectedCells[0].row
        const staffnumberLast = this.selectedCells.slice(-1)[0].row
        const start = this.selectedCells[0].col * 60 + this.selectedCells[0].min * 15
        const end = this.selectedCells.slice(-1)[0].col * 60 + this.selectedCells.slice(-1)[0].min * 15
  
        if (start < end) {
        this.editingStart = start
        this.editingEnd = end
        } else {
          this.editingStart = end
          this.editingEnd = start
        }
  
        console.log("safjgasfghjadfgja"+ this.staffIndex)
  
        // 選択されたスタッフを編集対象にする
        if (staffnumberFirst > staffnumberLast) {
          for (let i = staffnumberLast; i <= staffnumberFirst; i++) {
            this.selectedUser.push(this.staffIndex[i])
            console.log("@@@@@@@@@@:" + this.selectedUser)
          }
        } else {
          for (let i = staffnumberFirst; i <= staffnumberLast; i++) {
            this.selectedUser.push(this.staffIndex[i])
            console.log("@@@@@@@@@@:" + this.selectedUser)
          }
        }
      },
      getCellClass(isfill: boolean, row: number, col: number, min: number) {
          // 選択されたセルに一致するかをチェック
          const isSelected = this.selectedCells.some(
            (cell) => cell.row === row && cell.col === col && cell.min === min
          );
          return isSelected ? 'selected-cell' : '';
      },
      //削除処理の開始
      async deleteSelectedTable() {
        this.isFetching = true;
        this.isOverlayVisible = true;
        overlayModule.setVisible(true);
        this.loading = true;
        this.loadingCountNumerator = 1;
  
        await this.fetchDailySchedule();
        await this.initializeTablePosition();
  
        if (this.editingUser && this.editingDate) {
            const dateInt = dayjs(this.editingDate).date();
            const yearInt = parseInt(dayjs(this.editingDate).format("YYYY"));
            const monthInt = parseInt(dayjs(this.editingDate).format("MM"));
            await monthlyScheduleModule.getUserShiftPatternDay({
              userId: this.editingUser,
              year: yearInt,
              month: monthInt,
              day: dateInt,
            });
        }
  
        for (const cell of this.deleateTableId) {
          const matchingPositions = this.tablePosition.filter(position => position.tableID === cell);
          if (matchingPositions != null) {
            await this.initializeTablePosition();
          }
          const tabeleStart = matchingPositions[0].j * 60 + matchingPositions[0].k * 15;
          const tabeleEnd = matchingPositions.slice(-1)[0].j * 60 + matchingPositions.slice(-1)[0].k * 15;
  
          console.log("削除テーブル：" + JSON.stringify(matchingPositions));
          console.log("始点" + tabeleStart);
          console.log("終点" + tabeleEnd);
          //中抜き削除
          if (tabeleStart < this.editingStart && this.editingStart < tabeleEnd && tabeleStart < this.editingEnd && this.editingEnd < tabeleEnd) {
            // 後
            if (matchingPositions[0].category === "workDescription") {
              this.partialDelete.push({
                workDescriptionName: matchingPositions[0].tableInfo.name,
                start: this.editingEnd + 15,
                end: tabeleEnd,
                abbreviation: matchingPositions[0].tableInfo.abbreviation,
                color: matchingPositions[0].tableInfo.color,
                id: matchingPositions[0].tableInfo.workDescriptionId,
                category: matchingPositions[0].category,
              });
            } else if (matchingPositions[0].category === "break") {
              this.partialDelete.push({
                workDescriptionName: "休憩",
                start: this.editingEnd + 15,
                end: tabeleEnd,
                abbreviation: "休憩",
                color: "#808080",
                category: matchingPositions[0].category,
              });
            }
            if (this.partialDelete[0]) {
              this.editingDate = this.yearMonthDate;
              await this.addTimetableToEditingPattern("partialDelete");
              //前
              monthlyScheduleModule.editingShiftPattern?.timetables.forEach((timetable) => {
              if (timetable.timetableId === matchingPositions[0].tableID) {
                  timetable.endMin = this.editingStart
              }
              });
            }
          } else if (tabeleStart < this.editingStart && this.editingStart <= tabeleEnd) {
            monthlyScheduleModule.editingShiftPattern?.timetables.forEach((timetable) => {
            if (timetable.timetableId === matchingPositions[0].tableID) {
                timetable.endMin = this.editingStart
            }
            });
          } else if (tabeleStart <= this.editingEnd && this.editingEnd < tabeleEnd) {
            monthlyScheduleModule.editingShiftPattern?.timetables.forEach((timetable) => {
            if (timetable.timetableId === matchingPositions[0].tableID) {
                timetable.startMin = this.editingEnd + 15
            }
            });
          } else {
            // 削除処理を実行
            try {
              await this.removeTimetableFromEditingPattern(cell);
              console.log("削除準備完了しました: " + cell);
            } catch (error) {
              console.error("削除準備に失敗しました: " + cell, error);
              continue; // エラーがあっても次の `cell` に進む場合は `continue`
            }
          }
        }
  
        try {
            await this.saveEditingPattern(this.editingUser)
            console.log("削除が成功しました: ");
          } catch (error) {
            console.error("削除に失敗しました: ");
          }
  
        this.selectedCells = [];
        this.deleateTableId = [];
        this.partialDelete = [];
        await this.fetchDailySchedule();
        await this.initializeTablePosition();
        this.isSelecting = false;
        this.isFillCell = false;
        this.isFetching = false;
        this.loading = false;
        this.loadingCountNumerator = 0;
        this.isOverlayVisible = false;
        overlayModule.setVisible(false);
      },
      initializeTablePosition() {
        // scheduleTableRowsのデータを元にtablePositionを初期化
        this.scheduleTableRows.forEach((row, i) => {
          row.items.forEach((item, j) => {
            item.items.forEach((minItem, k) => {
              if (minItem.tableID) {
                this.tablePosition.push({ tableID: minItem.tableID, i, j, k, tableInfo: minItem.tableInfo, category: minItem.category});
              }
            });
          });
        });
        console.log("Initialized tablePosition:", this.tablePosition);
      },
     //時間枠の削除処理
      async removeTimetableFromEditingPattern(timetableId?: number) {
        if (monthlyScheduleModule.editingShiftPattern) {
          const newPattern = { ...monthlyScheduleModule.editingShiftPattern };
          if (timetableId) {
            newPattern.timetables = newPattern.timetables?.map((tt) => {
              if (tt.timetableId === timetableId) {
                tt.operationType = "remove";
              }
              return tt;
            });
          }
          monthlyScheduleModule.updateEditingPattern(newPattern);
        }
      },
      //時間枠の追加
      async addTimetableToEditingPattern(option) {
        this.loadingCountDenominator = this.selectedUser.length;
  
        // for...ofを使用して非同期ループを処理
        //for (const SelectedStaff of this.selectedUser) {
        this.editingDate = this.yearMonthDate;
  
        if (this.editingDate) {
          const dateInt = dayjs(this.editingDate).date();
          const yearInt = parseInt(dayjs(this.editingDate).format("YYYY"));
          const monthInt = parseInt(dayjs(this.editingDate).format("MM"));
          await monthlyScheduleModule.getUserShiftPatternDay({
            userId: this.selectedUser[0],
            year: yearInt,
            month: monthInt,
            day: dateInt,
          });
        }
  
        if (monthlyScheduleModule.editingShiftPattern) {
          console.log("aaaa" + monthlyScheduleModule.editingShiftPattern);
          console.log("ユーザ: " + this.editingUser);
          console.log("日付: " + this.editingDate);
          const newPattern = { ...monthlyScheduleModule.editingShiftPattern };
  
          if (option === "休憩") {
            const newTimetable: DayScheduleUpdateRequestTimetable = {
              operationType: "add",
              name: "休憩",
              abbreviation: "休憩",
              color: "#808080",
              startMin: this.editingStart,
              endMin: this.editingEnd + 15,
              comment: "",
              category: "break",
            };
  
            if (newPattern.timetables) {
              newPattern.timetables.push(newTimetable);
            } else {
              newPattern.timetables = [newTimetable];
            }
  
            // シフトパターンが未作成の場合、任意の名前、略称、色を追加
            if (!newPattern.abbreviation) {
              newPattern.abbreviation = "勤務";
              newPattern.color = "#029ec0";
              newPattern.name = "勤務";
            }
  
            if (newPattern.users) {
              newPattern.users=this.selectedUser;
            }
  
            //this.loadingCountNumerator += 1;
            await monthlyScheduleModule.updateEditingPattern(newPattern);
          } else if (option === "partialDelete") {
            // 部分削除の処理
            for (const cell of this.partialDelete) {
              console.log("rrrrrr" + cell.start + "-" + cell.end + "-" + cell.id);
              const newTimetable: DayScheduleUpdateRequestTimetable = {
                operationType: "add",
                name: cell.workDescriptionName,
                abbreviation: cell.abbreviation,
                color: cell.color,
                startMin: cell.start,
                endMin: cell.end + 15,
                comment: "",
                workDescriptionId: cell.id,
                category: cell.category,
              };
  
              if (newPattern.timetables) {
                newPattern.timetables.push(newTimetable);
              } else {
                newPattern.timetables = [newTimetable];
              }
            }
  
            if (newPattern.users) {
              newPattern.users=this.selectedUser;
            }
  
            await monthlyScheduleModule.updateEditingPattern(newPattern);
          } else {
            for (const dscription of this.workDescriptions) {
              if (dscription.name === option) {
                const newTimetable: DayScheduleUpdateRequestTimetable = {
                  operationType: "add",
                  name: dscription.name,
                  abbreviation: dscription.abbreviation,
                  color: dscription.color,
                  startMin: this.editingStart,
                  endMin: this.editingEnd + 15,
                  comment: "",
                  workDescriptionId: dscription.workDescriptionId,
                  category: "workDescription",
                };
  
                if (newPattern.timetables) {
                  newPattern.timetables.push(newTimetable);
                } else {
                  newPattern.timetables = [newTimetable];
                }
  
                // シフトパターンが未作成の場合、任意の名前、略称、色を追加
                if (!newPattern.abbreviation) {
                  newPattern.abbreviation = "勤務";
                  newPattern.color = "#029ec0";
                  newPattern.name = "勤務";
                }
                this.loadingCountNumerator += 1;
  
                if (newPattern.users) {
                  newPattern.users=this.selectedUser;
                }
  
                await monthlyScheduleModule.updateEditingPattern(newPattern);
              }
            }
          }
        }
  
        // 選択されたスタッフごとの保存処理を待つ
        if (!this.partialDelete[0]) {
          await this.saveEditingPattern(this.selectedUser[0]);
        }
        if (!this.partialDelete[0]) {
          // 処理完了後の後続処理
          this.selectedCells = [];
          await this.fetchDailySchedule();
          await this.initializeTablePosition();
          this.isFetching = false;
        }
      },
      //更新したシフトを保存する
      async saveEditingPattern(SelectedStaff) {
        if (this.editingUser && this.editingDate) {
          console.log("Saving....")
          console.log(`editingDate: ${this.editingDate}`)
          const dateInt = dayjs(this.editingDate).date();
          const yearInt = parseInt(dayjs(this.editingDate).format("YYYY"));
          const monthInt = parseInt(dayjs(this.editingDate).format("MM"));
  
  
          await monthlyScheduleModule.saveEditingPatternDay({
            userId: SelectedStaff,
            year: yearInt,
            month: monthInt,
            day: dateInt,
  
          });
          monthlyScheduleModule.updateEditingPattern(null);
          this.editingDate = null;
        }
        await this.fetchDailySchedule();
      },
      //作業内容一覧の取得
      getWorkDescriptions() {
        this.workDescriptions.forEach ((dscription) => {
        this.contextMenuOptions.push(dscription.name)
        }); 
      },
      openEditScheduleModal(child: AttendanceScheduleChildPartSchema, schedule: AttendanceScheduleDailyPartSchema) {
        this.editingChild = child
        this.editingChildSchedule = schedule
      },
      async saveEditingShcedule() {
        if (this.editingChildSchedule && this.editingChild) {
          this.isUpdatingSchedule = true
          if (this.editingChildSchedule[0].status === 'attending') {
            if (
              this.isEditScheduleModalOpen
              && this.editingChildSchedule[0]
              && this.editingChildSchedule[0].status == 'attending'
              && this.editingChildSchedule[0].startMin
              && this.editingChildSchedule[0].endMin
              && this.editingChildSchedule[0].startMin >= this.editingChildSchedule[0].endMin
            ) {
              this.isUpdatingSchedule = false
              return alert('登降園の時刻が前後または一致している場合は登録できません。');
            } else if (
              this.isEditScheduleModalOpen
              && this.editingChildSchedule[0]
              && this.editingChildSchedule[0].status == 'attending'
              && this.editingChildSchedule[0].startMin
              && !this.editingChildSchedule[0].endMin
            ) {
              this.isUpdatingSchedule = false
              return alert('登降園の時刻が前後または一致している場合は登録できません。');
            } else if (
              this.isEditScheduleModalOpen
              && this.editingChildSchedule[0]
              && this.editingChildSchedule[0].status == 'attending'
              && !this.editingChildSchedule[0].startMin
              && !this.editingChildSchedule[0].endMin
            ) {
              this.isUpdatingSchedule = false
              return alert('登降園の時刻が前後または一致している場合は登録できません。');
            }
            await attendanceScheduleModule.updateChildAttendanceSchedule({
              date: this.yearMonthDate,
              childId: this.editingChild.childId,
              abbreviation: this.editingChildSchedule[0].abbreviation || undefined,
              color: this.editingChildSchedule[0].color || undefined,
              status: this.editingChildSchedule[0].status || undefined,
              statusReason: this.editingChildSchedule[0].statusReason || undefined,
              startMin: this.editingChildSchedule[0].startMin || undefined,
              statusComment: this.editingChildSchedule[0].statusComment || undefined,
              endMin: this.editingChildSchedule[0].endMin || undefined
            })
          } else {
            await attendanceScheduleModule.updateChildAttendanceSchedule({
              date: this.yearMonthDate,
              childId: this.editingChild.childId,
              abbreviation: this.editingChildSchedule[0].abbreviation || undefined,
              color: this.editingChildSchedule[0].color || undefined,
              status: this.editingChildSchedule[0].status || undefined,
              statusReason: this.editingChildSchedule[0].statusReason || undefined,
              startMin: 0,
              statusComment: this.editingChildSchedule[0].statusComment || undefined,
              endMin: 0
            })
          }
          this.isUpdatingSchedule = false
          this.isEditScheduleModalOpen = false
        }
      },
      async deleteEditingShcedule() {
        if (this.editingChildSchedule && this.editingChild) {
          this.isUpdatingSchedule = true
          await attendanceScheduleModule.deleteChildAttendanceSchedule({
            date: this.yearMonthDate,
            childId: this.editingChild.childId,
            abbreviation: this.editingChildSchedule.abbreviation || undefined,
            color: this.editingChildSchedule.color || undefined,
            status: this.editingChildSchedule.status || undefined,
            statusReason: this.editingChildSchedule.statusReason || undefined,
            startMin: this.editingChildSchedule.startMin || undefined,
            statusComment: this.editingChildSchedule.statusComment || undefined,
            endMin: this.editingChildSchedule.endMin || undefined
          })
          this.isUpdatingSchedule = false
          this.isEditScheduleModalOpen = false
        }
      },
      // 相対輝度を計算する関数
      calculateRelativeLuminance(hexColor: string): number {
        const r = parseInt(hexColor.slice(1, 3), 16) / 255;
        const g = parseInt(hexColor.slice(3, 5), 16) / 255;
        const b = parseInt(hexColor.slice(5, 7), 16) / 255;
  
        const luminance = (channel: number) => {
          return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
        };
  
        return 0.2126 * luminance(r) + 0.7152 * luminance(g) + 0.0722 * luminance(b);
      },
      // コントラスト比を計算する関数
      calculateContrastRatio(color1: string, color2: string): number {
        const luminance1 = this.calculateRelativeLuminance(color1);
        const luminance2 = this.calculateRelativeLuminance(color2);
        const lighter = Math.max(luminance1, luminance2);
        const darker = Math.min(luminance1, luminance2);
        return (lighter + 0.05) / (darker + 0.05);
      },
      openUpdatePlacement() {
        this.isUpdatePlacement = true;
      },
      async UpdateExpectedPlacement() {
        this.isFetching = true;
        this.isUpdatePlacement = false;
        await new Promise((resolve) => setTimeout(resolve, 20000));
        console.log("計算開始");
        await dailyScheduleModule.UpdateExpectedPlacement();
        await new Promise((resolve) => setTimeout(resolve, 5000));
        console.log("計算完了");
        await this.fetchDailySchedule();
        this.isFetching = false;
      },
    },
    async mounted() {
      this.isFetching = true;
      const wsdate = sessionStorage.getItem('wsdate')
      const displaySettings = await attendanceScheduleModule.getDisplaySetting();
      if (displaySettings) {
        this.selectedDisplayItems = this.availableItems
          .filter(item => displaySettings[item.name]) // displaySettingsの該当プロパティがtrueのものだけ抽出
          .map(item => item.id);
      }
      const queries = this.$route.query
      if (queries.date) {
        const dateString = queries.date as string
        const date = dayjs(dateString).format('YYYY-MM-DD')
        dailyScheduleModule.setYearMonthDate(date)
      } else {
        const date = dayjs().format('YYYY-MM-DD')
        dailyScheduleModule.setYearMonthDate(date)
      }
  
      if (wsdate) {
        dailyScheduleModule.setYearMonthDate(wsdate);
      }
  
      await Promise.all([
        this.fetchDailySchedule(),
        ///attendance-schedule/${year}/${month}/childrenを呼び出す（園児予定一覧のAPI）
        attendanceScheduleModule.listAttendanceSchedules(),
        attendanceScheduleModule.listClass(),
        ////GET/attendance/searchを呼び出す（出欠データのAPI）
        this.searchAttendance()
      ]);
  
      await Promise.all([
        this.initializeTablePosition(),
        workDescriptionModule.listWorkDescriptions(),
      ]);
  
      this.getWorkDescriptions()
      this.selectedClassId = this.classes[0].classId
      this.isFetching = false;
    }
  })
  </script>
  
  <style lang="scss" scoped>
  /* ------------------------------------------------------------- */
  /* CSSの start / end などの非推奨プロパティをVuetify3向けに left / right に置換 */
  /* ------------------------------------------------------------- */
  .panel-header {
    display: flex;
    border-bottom: solid 2px #e0e0e0;
  }
  
  .panel-left {
    border-right: solid 2px #e0e0e0;
  }
  
  .panel-right {
    border-left: solid 2px #e0e0e0;
  }
  
  .schedule-col {
  
    border-right: solid 1px #f0f0f0;
    &.name {
      width: 340px;
    }
    &.count {
      width: 50px;
    }
  
    &.hour {
      width: 200px;
      height: 25px;
      padding: 0;
    }
  
    &.actions {
      width: 100px;
      padding-left: 4px;
      padding-right: 4px;
    }
  }
  
  .header-col {
    padding: 8px;
    font-weight: bold;
    text-align: center;
    font-size: 12px;
    // height: 50px;
    padding: 0;
  }
  .hour-col {
    height: 25px;
    border-right: solid 1px #f0f0f0;
    border-bottom: solid 1px #f0f0f0;
  }
  .min-cols {
    display: flex;
  }
  
  .min-col {
    width: 50px;
    // height: 75px;
    // height: 25px;
    border-right: solid 1px #f0f0f0;
  }
  
  .schedule-header-cell {
    font-weight: bold;
    text-align: center;
    font-size: 12px;
    height: 50px;
    user-select: none;
  }
  
  .schedule-row {
    display: flex;
    height: 45px;
    border-bottom: solid 1px #f0f0f0;
    background-color: white;
    user-select: none;
  }
  
  .body-cell-hour {
    display: flex;
  }
  /* --------------------------------------------- */
 /* カーソル関連の修正 */
 /* --------------------------------------------- */
 .body-cell-drawing {
   /* !important で子要素に邪魔されないように強制します */
   /* ホットスポット(4 28) が下すぎる場合は、0 24 など画像に合わせて調整してください */
   cursor: url('~/public/img/pencil.png') 0 24, auto !important;
 }
 .body-cell-removing {
   cursor: url('~/public/img/eraser.png') 8 24, auto !important;
 }
 .body-cell-error-drawing {
   cursor: url('~/public/img/pencil-remove.png') 0 24, auto !important;
 }

 .body-cell-minute {
   width: 50px;
   height: 45px;
   font-size: 14px;
   text-align: center;
   border-right: solid 1px #f0f0f0;
   
   /* 背景色や透明度を変えるときのトランジション */
   transition: all 0.2s; 

   &:hover {
     opacity: 0.6;
     background: #e0e0e0;
   }
 }

 .body-cell-minute-content {
   color: white;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   pointer-events: none; 
 }
  
  .schedule-body-cell {
    font-size: 14px;
    text-align: center;
    padding: 8px 0;
  
    &.date.active {
      cursor: pointer;
      height: 100%;
      &:hover {
        transition-property: all;
        transition-duration: .2s;
        opacity: .6;
      }
    }
  
    &.date.add {
      cursor: pointer;
      height: 100%;
      &:hover {
        transition-property: all;
        transition-duration: .2s;
        background-color: #f0f0f0;
      }
    }
  }
  
  .replacement-heading-box {
    height: 25px;
    width: 340px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: solid 1px #f0f0f0;
  }
  .replacement-label {
    width: 100%;
    color: #029ec0;
    font-size: 13px;
    text-align: center;
    font-weight: 400;
  
    &.-secondary {
      color: #ff9800;
    }
  
    &.-tertiary {
      color: #e81e79;
    }
  
    &.-quaternary {
      color: #11bc7a;
    }
  
    &.bold {
      font-weight: bold;
    }
  }
  
  .minute-box {
    height: 25px;
    width: 100%;
    border-top: solid 1px #f0f0f0;
  }
  
  .tabs-container {
    margin-top: 40px;
    margin-bottom: 40px; /* 下のマージンを36pxに設定 */
  }
  
  .custom-tab {
    width:  33%;
  }
  
  .staff-table {
    max-height: 100px; /* スクロール領域の高さを指定 */
    overflow-y: auto; /* 縦スクロールを有効化 */
  }
  
  /* 選択されたセルのスタイル */
    .selected-cell {
      z-index: 101 !important;
      background-color: #ffcccb !important;/* 背景色 */
      border: 2px solid #ff0000 !important;/* 枠線の色と太さ */
    }
    .isfilled-cell {
      z-index: 101 !important;
      background-color: #ffffff !important;/* 背景色 */
      border: 2px solid #000000 !important;/* 枠線の色と太さ */
    }
    .selectedoff-cell {
      background-color: #ffffff !important;/* 背景色 */
    }
  
    .context-menu {
    list-style-type: none;
    padding: 10px;
    margin: 0;
    background-color: #f0f0f0;
    border: 1px solid #E4E3E1;
    border-radius: 5px;
  }
  .context-menu li {
    padding: 5px;
    cursor: pointer;
    background-color: #f0f0f0;
    border-radius: 5px;
  }
  .context-menu li:hover {
    background-color: #029ec0;
  }
  /* 画面全体を覆う半透明オーバーレイ */
  .overlay {
    position: fixed;
    top: 0;
    left: 0; /* ⭕️ 修正8: start: 0; -> left: 0; */
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* 黒色で半透明に */
    z-index: 100; /* 他の要素より前面に表示 */
  }
  .circle {
    position: fixed;
    right: 40px; /* ⭕️ 修正9: end: 40px; -> right: 40px; */
    bottom: 40px; /* 画面下からの距離 */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #ffffff; /* 任意の背景色 */
    border: 3px solid #E4E3E1; /* 任意のボーダーカラー */
  }
  
  .checklist .checklist-item {
    display: flex;
    flex-direction: column;
  }
  
  .checklist .checklist-item .v-input {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1 !important; /* 行の高さを詰める */
  }
  
  .checklist .checklist-item hr {
    margin: -12px 0 8px 0 !important;
    padding: 0 !important;
    height: 1px; /* 線の高さを最小に */
    border: none;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  </style>